import { axiosInstance } from "../../../axios/axiosInstance";

const API_SERVICE_PROVIDER_CUSTOMERS_URL = "organization/customers";
const API_SERVICE_PROVIDER_CUSTOMERS_MODULE_LIST_URL = API_SERVICE_PROVIDER_CUSTOMERS_URL + "/list";
const API_SEARCH_SERVICE_PROVIDER_CUSTOMERS_URL = API_SERVICE_PROVIDER_CUSTOMERS_URL + "/search";
const API_GET_SERVICE_PROVIDER_CUSTOMER_DETAILS_URL = API_SERVICE_PROVIDER_CUSTOMERS_URL + "/view";
const API_UPDATE_SERVICE_PROVIDER_CUSTOMER_MODULE_STATUS_URL = API_SERVICE_PROVIDER_CUSTOMERS_URL + "/update-status";


export const getServiceProviderCustomers = (dataToBeSent) => {
  return axiosInstance.get(`${API_SERVICE_PROVIDER_CUSTOMERS_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}&filters[country]=${dataToBeSent?.country || ""}`);
};

export const updateServiceProviderCustomerStatus = ({selectedServiceProviderCustomerId, ...rest}) => {
  return axiosInstance.post(API_UPDATE_SERVICE_PROVIDER_CUSTOMER_MODULE_STATUS_URL + "/" + selectedServiceProviderCustomerId, {...rest});
};

export const searchCustomers = (dataToBeSent) => {
  return axiosInstance.get(`${API_SEARCH_SERVICE_PROVIDER_CUSTOMERS_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};

export const getCustomerDetails = (dataToBeSent) => {
  return axiosInstance.get(API_GET_SERVICE_PROVIDER_CUSTOMER_DETAILS_URL + "/" + dataToBeSent?.selectedServiceProviderCustomerId);
};
